import React, { useState } from 'react';
import {
  View,
  StyleSheet,
  Text,
  TouchableOpacity,
  Platform,
} from 'react-native';

import EditUserProfileDialog, {
  InformationToEdit,
} from './EditUserProfileDialog';

import { useConsumerStatusSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import UserAddress from 'shared/modules/account/components/organisms/UserAddress';
import UserName from 'shared/modules/account/components/organisms/UserName';
import generateID from 'shared/modules/common/utils/generate-id';
import eventBus from 'shared/utils/event-bus';
import { isPlusUser } from 'utils/user-types';

const ProfileDetails = () => {
  const { data } = useConsumerStatusSummaryQuery();
  const houkatsuStatus = data?.houkatsuStatus?.status;
  const kycStatus = data?.KYCApplicationStatus?.status;
  const isPlus = isPlusUser(kycStatus, houkatsuStatus);
  const [informationToEdit, setInformationToEdit] = useState<InformationToEdit>(
    'name'
  );
  const [isEditUserProfileDialogOpen, setEditUserProfileDialogOpen] = useState(
    false
  );

  const openEditDialog = (information: InformationToEdit) => {
    return () => {
      setInformationToEdit(information);
      setEditUserProfileDialogOpen(true);
    };
  };

  return (
    <>
      {isPlus && (
        <View style={style.editInstructionsMessageBox}>
          <Text style={[style.editInstructionsMessageText, style.pinkText]}>
            ※
          </Text>
          <Text style={style.editInstructionsMessageText}>
            お名前および現住所の変更は本人確認が必要となるため、ペイディアプリから変更してください。本人確認の詳細は
            <Text
              {...Platform.select({
                web: {
                  accessibilityRole: 'link',
                  href:
                    'https://cs-support.paidy.com/support/solutions/folders/150000270422',
                  hrefAttrs: {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  },
                },
              })}
              style={[style.editInstructionsMessageText, style.pinkText]}
              /** Generate HTML and Test IDs  */
              {...generateID('profile-details-support-link')}
            >
              こちら
            </Text>
            からご確認ください。
            <TouchableOpacity
              onPress={() => eventBus.emit('appdl:open')}
              accessibilityRole="button"
              /** Generate HTML and Test IDs  */
              {...generateID('profile-details-open-download-link-button')}
            >
              <Text
                style={[
                  style.editInstructionsMessageText,
                  style.pinkText,
                  style.boldText,
                ]}
              >
                ペイディアプリを開く
              </Text>
            </TouchableOpacity>
          </Text>
        </View>
      )}
      <UserName onEditButtonPress={openEditDialog('name')} />
      <View style={style.separator} />
      <UserAddress onEditButtonPress={openEditDialog('address')} />
      <EditUserProfileDialog
        informationToEdit={informationToEdit}
        open={isEditUserProfileDialogOpen}
        onCloseButtonPress={() => setEditUserProfileDialogOpen(false)}
      />
    </>
  );
};

const style = StyleSheet.create({
  separator: {
    height: 40,
  },
  editInstructionsMessageBox: {
    borderColor: '#e5258c',
    borderWidth: 1,
    borderRadius: 8,
    padding: 16,
    marginBottom: 32,
    flexDirection: 'row',
  },
  editInstructionsMessageText: {
    fontSize: 12,
  },
  pinkText: {
    color: '#e5258c',
  },
  boldText: {
    fontWeight: 'bold',
  },
});

export default ProfileDetails;
